import { Component } from "@angular/core";

// import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {
  NavController,
  AlertController,
  LoadingController,
  Loading,
  ModalController,
} from "ionic-angular";

// O provider para se comunicar com o servidor online
import { ApiProvider } from "../../providers/api/api";

// Salvar no storage
import { Storage } from "@ionic/storage";

// Login no facebook
import { Facebook, FacebookLoginResponse } from "@ionic-native/facebook";

import { TabsPage } from "../tabs/tabs";
import { RegisterPage } from "../register/register";
import { LoginpadraoPage } from "../loginpadrao/loginpadrao";
import { LinguaPage } from "../lingua/lingua";

import { TranslateService } from "@ngx-translate/core";
import { TranslateMsgProvider } from "../../providers/translate-msg/translate-msg";

@Component({
  selector: "page-login",
  templateUrl: "login.html",
})
export class LoginPage {
  loading: Loading;
  registerCredentials = { email: "", senha: "" };
  imagem: string;
  dadosFacebook: object;

  constructor(
    private nav: NavController,
    private alertCtrl: AlertController,
    private loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    private _apiService: ApiProvider,
    private storage: Storage,
    private fb: Facebook,
    public translate: TranslateService,
    private _msg: TranslateMsgProvider
  ) {
    this._apiService.getLogo().subscribe((arg) => {
      this.imagem = arg.config.imagem;
    });

    this.checkLingua();
  }

  checkLingua() {
    if (this.translate.getDefaultLang() == null) {
      let modalLng = this.modalCtrl.create(LinguaPage);
      modalLng.onDidDismiss((data) => {
        this.checkLingua();
      });
      modalLng.present();
    }
  }

  /* Função para redirecionar para a página de cadastro */
  public createAccount() {
    this.nav.push(RegisterPage);
  }

  /* Redirecionar para o login */
  login() {
    // modal.present();
    this.nav.push(LoginpadraoPage);

    return false;
  }

  /* Exibe mensagem de loading*/
  showLoading() {
    this.loading = this.loadingCtrl.create({
      content: this._msg.getMsg("CARREGANDO") + "...",
      dismissOnPageChange: true,
    });
    this.loading.present();
  }

  /* Exibe erro */
  showPopup(titulo, text) {
    this.loading.dismiss();

    let alert = this.alertCtrl.create({
      title: titulo,
      subTitle: text,
      buttons: ["OK"],
    });
    alert.present();
  }

  /* Login pelo facebook */
  // facebook()
  // {
  //     this.fb.getLoginStatus().then((res) => {
  //         if (res.status === 'connected')
  //         {
  //             this.facebookReturn(res);
  //         }
  //         else
  //         {
  //             this.fb.login(['public_profile', 'user_friends', 'email'])
  //             .then((res2: FacebookLoginResponse) => this.facebookReturn(res2)).catch(e => this.erroFacebook(e));
  //         }
  //     });
  // }

  facebook() {
    
    let env = this;

    //@ts-ignore
    FB.login(
      function (res) {
        if (res.status == "connected") {
      
          //@ts-ignore
          FB.api("/me?fields=name,email", function (res: any) {
            console.log('response do .api', res);
            env._apiService
              .cadfacebook(res.id, res.name, res.email)
              .subscribe((arg) => {
                console.log(arg);
                // loader.dismiss();

                env.storage.set("id_cliente", arg.id_cliente);
                console.log('cliente',env.storage.get('id_cliente'));
                env.storage.set("nome", arg.nome);
                env.storage.set("facebook", 1);

                env.nav.setRoot(TabsPage);
              });
          });
        }
      },
      { scope: "public_profile,email" }
    );
  }

  // Quando o facebook retorna erro
  erroFacebook(e) {
    let env = this;
    console.log("Error logging into Facebook", e);
    const alert = this.alertCtrl.create({
      title: this._msg.getMsg("ERRO"),
      subTitle: this._msg.getMsg("ERRO_FACEBOOK"),
      buttons: ["Ok"],
    });
    alert.present();
    env.nav.setRoot(TabsPage);
  }

  /* Função para tratar retorno do facebook */
  facebookReturn(res) {
    console.log("retorno ok", res);

    if (res.status == "connected") {
      // console.log('if');

      let loader = this.loadingCtrl.create({
        content: "Carregando...",
      });
      loader.present();

      let id_face = res.authResponse.userID;
      // console.log(id_face);

      // Pega os dados para cadastrar
      let env = this;

      let params = new Array<string>();
      this.fb.api("/me?fields=name,email", params).then(function (user) {
        // Envia para api
        env._apiService
          .cadfacebook(id_face, user.name, user.email)
          .subscribe((arg) => {
            console.log(arg);
            loader.dismiss();

            env.storage.set("id_cliente", arg.id_cliente);
            // console.log('cliente',env.storage.get('id_cliente'));
            env.storage.set("nome", arg.nome);
            env.storage.set("facebook", 1);

            env.nav.setRoot(TabsPage);
          });
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts